/* Saide – "Wrap for" gift wrap allocation
   Adds a dropdown under each gift wrap line in the cart drawer and cart page so the
   customer can choose which item to wrap. The choice is saved on the gift wrap line
   as the line item property "Wrap for", which shows on the order in Shopify admin.
   Independent of Selleasy – it only reads the cart and updates the gift wrap line. */
(function () {
  'use strict';

  var CONFIG = {
    wrapHandles: ['gift-wrap', 'gold-gift-wrap'],
    wrapTypeMatch: /gift\s*wrap/i,
    propertyName: 'Wrap for',
    allTogetherLabel: 'All items, wrapped together',
    label: 'Which item would you like us to wrap?',
    placeholder: 'Choose an item',
    reminder: 'Just let us know which item you’d like wrapped before checking out.',
    separator: '; '
  };

  var busy = false;
  var renderQueued = false;

  function isWrap(item) {
    return CONFIG.wrapHandles.indexOf(item.handle) !== -1 ||
      CONFIG.wrapTypeMatch.test(item.product_type || '');
  }

  function itemLabel(item) {
    var label = item.product_title || item.title;
    if (item.variant_title && !/default/i.test(item.variant_title)) {
      label += ' – ' + item.variant_title;
    }
    return label;
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function savedParts(item) {
    var v = item.properties && item.properties[CONFIG.propertyName];
    return v ? String(v).split(CONFIG.separator) : [];
  }

  function validOptions(cart) {
    var opts = [];
    cart.items.forEach(function (it) {
      if (isWrap(it)) return;
      var l = itemLabel(it);
      if (opts.indexOf(l) === -1) opts.push(l);
    });
    if (opts.length > 1) opts.push(CONFIG.allTogetherLabel);
    return opts;
  }

  // Returns the saved choice per unit, blanking any that no longer match the cart
  function choicesFor(item, options) {
    var parts = savedParts(item);
    var out = [];
    for (var i = 0; i < item.quantity; i++) {
      var p = parts[i] || '';
      out.push(options.indexOf(p) !== -1 ? p : '');
    }
    return out;
  }

  function isAssigned(item, options) {
    return choicesFor(item, options).every(function (c) { return c !== ''; });
  }

  function saveChoice(item, choices, quiet) {
    var props = {};
    Object.keys(item.properties || {}).forEach(function (k) { props[k] = item.properties[k]; });
    var filled = choices.filter(function (c) { return c; });
    if (filled.length) {
      props[CONFIG.propertyName] = choices.map(function (c) { return c || '?'; }).join(CONFIG.separator);
    } else {
      delete props[CONFIG.propertyName];
    }
    busy = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
    }).then(function (r) {
      busy = false;
      if (r.ok && !quiet) refreshCartUI();
    }).catch(function () { busy = false; });
  }

  function refreshCartUI() {
    if (isCartPage()) { window.location.reload(); return; }
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load();
    } else {
      queueRender();
    }
  }

  function isCartPage() {
    return /(^|\s)template-cart(\s|$)/.test(document.body.className);
  }

  // Find every place a given line (1-indexed) is shown: the cart drawer and/or the cart page
  function rowsFor(line) {
    var found = [];
    var drawerRow = document.querySelector('#CartContainer .ajaxcart__row[data-line="' + line + '"]');
    if (drawerRow) {
      found.push({ el: drawerRow.querySelector('.ajaxcart__product-name--wrapper') || drawerRow, drawer: true, row: drawerRow });
    }
    if (isCartPage()) {
      var rows = Array.prototype.filter.call(
        document.querySelectorAll('form.cart > .cart__row'),
        function (r) { return !r.classList.contains('cart__header-labels') && !r.classList.contains('cart__row--last'); }
      );
      var r = rows[line - 1];
      if (r) {
        var name = r.querySelector('.cart__product-name');
        found.push({ el: name ? name.parentNode : r, drawer: false, row: r });
      }
    }
    return found;
  }

  function buildPicker(item, options) {
    var wrap = document.createElement('div');
    wrap.className = 'saide-wrapfor';
    wrap.setAttribute('data-wrap-key', item.key);

    var choices = choicesFor(item, options);
    var label = document.createElement('label');
    label.className = 'saide-wrapfor__label';
    label.textContent = item.quantity > 1 ? CONFIG.label.replace('item', 'items') : CONFIG.label;
    wrap.appendChild(label);

    choices.forEach(function (choice, idx) {
      var sel = document.createElement('select');
      sel.className = 'saide-wrapfor__select';
      var id = 'WrapFor-' + item.key.replace(/[^a-z0-9]/gi, '') + '-' + idx;
      sel.id = id;
      if (idx === 0) label.setAttribute('for', id);
      if (item.quantity > 1) sel.setAttribute('aria-label', 'Gift wrap ' + (idx + 1));

      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = item.quantity > 1 ? 'Wrap ' + (idx + 1) + ': ' + CONFIG.placeholder.toLowerCase() : CONFIG.placeholder;
      sel.appendChild(ph);
      options.forEach(function (o) {
        var opt = document.createElement('option');
        opt.value = o;
        opt.textContent = o;
        if (o === choice) opt.selected = true;
        sel.appendChild(opt);
      });

      sel.addEventListener('change', function () {
        var current = Array.prototype.map.call(wrap.querySelectorAll('select'), function (s) { return s.value; });
        wrap.classList.remove('saide-wrapfor--error');
        saveChoice(item, current);
      });
      wrap.appendChild(sel);
    });

    var msg = document.createElement('p');
    msg.className = 'saide-wrapfor__msg';
    msg.textContent = CONFIG.reminder;
    wrap.appendChild(msg);
    return wrap;
  }

  function hideRawProperty(rowInfo) {
    if (!rowInfo.drawer) return;
    Array.prototype.forEach.call(rowInfo.row.querySelectorAll('.ajaxcart__product-meta'), function (s) {
      if (s.textContent.trim().indexOf(CONFIG.propertyName + ':') === 0) s.style.display = 'none';
    });
  }

  function render() {
    renderQueued = false;
    if (busy) return;
    getCart().then(function (cart) {
      document.querySelectorAll('.saide-wrapfor').forEach(function (n) { n.remove(); });
      window.__saideCart = cart;
      var options = validOptions(cart);
      var nonWrap = cart.items.filter(function (it) { return !isWrap(it); });

      cart.items.forEach(function (item, i) {
        if (!isWrap(item)) return;

        // Only one product in the cart – assign it automatically
        if (nonWrap.length === 1 && item.quantity === 1 && !isAssigned(item, options)) {
          saveChoice(item, [itemLabel(nonWrap[0])]);
          return;
        }
        if (!options.length) return;

        rowsFor(i + 1).forEach(function (rowInfo) {
          hideRawProperty(rowInfo);
          rowInfo.el.appendChild(buildPicker(item, options));
        });
      });

      // Sent here from the Selleasy pop-up – point them straight to the dropdown
      if (isCartPage() && /[?&]wrap=choose/.test(window.location.search)) {
        var missing = cart.items.filter(function (it) { return isWrap(it) && !isAssigned(it, options); });
        if (missing.length) highlightMissing(missing, document.querySelector('main') || document);
      }
    }).catch(function () {});
  }

  function queueRender() {
    if (renderQueued) return;
    renderQueued = true;
    setTimeout(render, 150);
  }

  // ---- Checkout guard -------------------------------------------------------
  // Catches every route to checkout – the theme's Checkout buttons and the
  // "Continue" button in the Selleasy pop-up – and checks the live cart first.
  var allowEl = null;
  var CLICKABLE = 'button, a, [role="button"], input[type="submit"], input[type="button"]';

  function isCheckoutish(el) {
    if (el.getAttribute('name') === 'checkout' || el.classList.contains('cart__checkout')) return true;
    var href = el.getAttribute('href') || '';
    if (/\/checkout/.test(href)) return true;
    var text = (el.value || el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!text || text.length > 40) return false;
    if (/shopping|browsing/.test(text)) return false;
    return /check ?out/.test(text) || /^continue\b/.test(text);
  }

  function findClickable(e) {
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n.nodeType === 1 && n.matches && n.matches(CLICKABLE)) return n;
    }
    return e.target && e.target.closest ? e.target.closest(CLICKABLE) : null;
  }

  function proceed(el) {
    allowEl = el;
    el.click();
    setTimeout(function () { if (allowEl === el) allowEl = null; }, 1000);
  }

  function highlightMissing(missing, scope) {
    var first = null;
    missing.forEach(function (it) {
      Array.prototype.forEach.call(document.querySelectorAll('.saide-wrapfor[data-wrap-key="' + it.key + '"]'), function (node) {
        node.classList.add('saide-wrapfor--error');
        if (!first && (!scope || scope.contains(node))) first = node;
      });
    });
    if (first) {
      if (first.scrollIntoView) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var s = first.querySelector('select');
      if (s) s.focus({ preventScroll: true });
    }
    return first;
  }

  window.addEventListener('click', function (e) {
    var el = findClickable(e);
    if (!el || el.closest('.saide-wrapfor') || !isCheckoutish(el)) return;
    if (allowEl === el) { allowEl = null; return; }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    getCart().then(function (cart) {
      window.__saideCart = cart;
      var options = validOptions(cart);
      var missing = cart.items.filter(function (it) { return isWrap(it) && !isAssigned(it, options); });
      if (!missing.length || !options.length) { proceed(el); return; }

      // One product in the cart – assign it, then carry on to checkout
      var nonWrap = cart.items.filter(function (it) { return !isWrap(it); });
      if (nonWrap.length === 1 && missing.every(function (it) { return it.quantity === 1; })) {
        Promise.all(missing.map(function (it) { return saveChoice(it, [itemLabel(nonWrap[0])], true); }))
          .then(function () { proceed(el); });
        return;
      }

      // Checkout button in the drawer or cart page – show the dropdown right there
      var form = el.closest('form');
      if (form && form.querySelector('.saide-wrapfor')) {
        highlightMissing(missing, form);
        return;
      }

      // Anywhere else (e.g. the Selleasy pop-up) – send them to the cart page to choose
      window.location.href = '/cart?wrap=choose';
    }).catch(function () { proceed(el); });
  }, true);

  function addStyles() {
    var css =
      '.saide-wrapfor{margin:10px 0 4px;}' +
      '.saide-wrapfor__label{display:block;font-size:0.85em;margin:0 0 6px;letter-spacing:0.02em;}' +
      '.saide-wrapfor__select{display:block;width:100%;max-width:340px;font-size:14px;padding:8px 10px;margin:0 0 6px;border:1px solid #d9d4cc;border-radius:2px;background-color:#fff;}' +
      '.saide-wrapfor__msg{display:none;font-size:0.85em;margin:2px 0 0;color:#8a5a44;}' +
      '.saide-wrapfor--error .saide-wrapfor__select{border-color:#8a5a44;}' +
      '.saide-wrapfor--error .saide-wrapfor__msg{display:block;}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  function init() {
    addStyles();
    var container = document.getElementById('CartContainer');
    if (container && window.MutationObserver) {
      new MutationObserver(function (muts) {
        var ours = muts.every(function (m) {
          return Array.prototype.every.call(m.addedNodes, function (n) { return n.classList && n.classList.contains('saide-wrapfor'); }) &&
                 Array.prototype.every.call(m.removedNodes, function (n) { return n.classList && n.classList.contains('saide-wrapfor'); });
        });
        if (!ours) queueRender();
      }).observe(container, { childList: true, subtree: true });
    }
    if (isCartPage()) render();
    else if (container && container.children.length) queueRender();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
